// eslint-disable-next-line import/prefer-default-export
export const GA_TRACKING_ID: string = process.env.NEXT_PUBLIC_GA_ID || "";
